import CA_Animation from "./CA_Animation.js";

/**
 * Will hide the horizontal ruler and if intersecting it gets visible and expands its width from 0 to full
 *
 * @since 1.1.0
 *
 * @author Alexander Uhlemann
 */
export default class CA_HorizontalRuleAnimation extends CA_Animation {
  /**
   * The constructor takes the config for this animation and
   * calls it's parent class constructor
   *
   * @param { object } config The configurations for the animation
   */
  constructor(config) {
    super("horizontal-rule-animation", config);
  }

  /**
   * This function is necessary for the Animator, it gets called if the HTMLElement is intersecting
   *
   * @since 1.1.0
   *
   * @author Alexander Uhlemann
   *
   * @param { HTMLElement } element The element which intersects and should be animated
   * @param { string } scrollDirection Contains the direction the user was scrolling when the element got intersected. Is either "down" or "up".
   *
   * @returns { void }
   */
  animate = (element, scrollDirection) => {
    // Get the duration for the animation from the dataset
    let duration = element.dataset.caDuration;

    // Set the transition duration style for it, and we only have to set it once, thats why we are doing it inside the if
    element.style.transitionDuration = duration + "ms";

    element.classList.remove("opacity-0", "w-[0px]");
    element.classList.add("w-full");
  };

  /**
   * This function gets called by the Animator, when the element is out of sight and we can prepare for the next animation
   *
   * @since 1.1.0
   *
   * @author Alexander Uhlemann
   *
   * @param { HTMLElement } element The element which was intersecting and should now be prepared
   * @param { string } scrollDirection Contains the direction the user was scrolling when the element got out of sight. Is either "down" or "up".
   *
   * @returns { void }
   */
  prepareForNextIntersecting = (element, scrollDirection) => {
    element.classList.add("w-[0px]", "opacity-0");
    element.classList.remove("w-full");
  };
}
